import {isValidNumber} from 'libphonenumber-js';

import {
  DATE_OF_BIRTH_REGEXP,
  NO_SYMBOLS_ADDRESS_REGEXP,
  NO_SYMBOLS_NO_NUMBERS_REGEXP,
  NO_SYMBOLS_REGEXP,
  PO_BOX_REGEX,
  US_ZIP_REGEXP,
  VALID_EMAIL_REGEXP,
  VALID_URL_REGEXP,
} from '../../../constants';

import {InputTypeProp} from './types';

type InputValidator = (
  type: InputTypeProp,
  value: string,
  required?: boolean,
) => boolean;

type NumInputValidator = (payload: {
  value: number;
  min?: number;
  max?: number;
}) => boolean;

export const stringTypes: InputTypeProp[] = [
  'string',
  'mobilePhone',
  'currency',
  'zip',
  'number',
];

type ValidatorHandler = {
  [key in InputTypeProp]?: (val: string) => boolean;
};

const isValidEmail = (email: string): boolean => {
  // Normal Email Validation
  if (!VALID_EMAIL_REGEXP.test(email)) return false;

  // Validation to check if an email contains .con inside the domain
  const domain = email.split('@')[1];

  return !domain?.includes('.con');
};

export const validatorsHandler: ValidatorHandler = {
  zip: (val) => US_ZIP_REGEXP.test(val),
  email: (val) => isValidEmail(val),
  string: (val) => val.length <= 100,
  mobilePhone: (val) => isValidNumber(val, 'US'),
  url: (val) => VALID_URL_REGEXP.test(val),
  currency: (val) => val.length <= 9,
  number: (val) => val.length <= 9,
  dateOfBirth: (val) => DATE_OF_BIRTH_REGEXP.test(val),
  socialSecurityNumber: (val) => val.length === 9,
  address: (val) =>
    !PO_BOX_REGEX.test(val) && NO_SYMBOLS_ADDRESS_REGEXP.test(val),
  stringNoSymbolsNoNumbers: (val) => {
    const newVal = val.trim();

    if (newVal[0] === '0') {
      return false;
    }

    return NO_SYMBOLS_NO_NUMBERS_REGEXP.test(val);
  },
  stringNoSymbols: (val) => NO_SYMBOLS_REGEXP.test(val),
};

export const inputValidator: InputValidator = (
  type,
  value,
  required = false,
) => {
  if (typeof value === 'undefined') {
    return true;
  }

  const hasValue = !!value?.length;
  const validator = validatorsHandler[type];

  if (hasValue && validator) {
    return validator(value);
  }

  return !required || hasValue;
};

export const numInputValidator: NumInputValidator = ({value, min, max}) => {
  if (typeof min !== 'undefined' && value < min) {
    return false;
  }

  if (typeof max !== 'undefined' && value > max) {
    return false;
  }

  return true;
};
